module.exports = __webpack_public_path__ + "static/media/pierre.2f62ae7a.jpeg";